import { Typography } from '@mui/material';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { MEIO_JULGAMENTO_SESSAO } from '@/dominio/MeioJulgamentoSessao';
import { action, computed, extendObservable, makeObservable, observable, runInAction, when } from 'mobx';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import PautaService from '@/service/PautaService';
import ValidacaoPreSessaoService from '@/service/ValidacaoPreSessaoService';
import Ambiente from '@/util/Ambiente';
import AcordaoService from '../service/AcordaoService';
import AdvogadoSustentacaoOralService from '../service/AdvogadoSustentacaoOralService';
import AssinaturaService from '../service/AssinaturaService';
import CertidaoService from '../service/CertidaoService';
import HealthCheckService from '../service/HealthCheckService';
import MovimentoCNJService from '../service/MovimentoCNJService';
import ProcessoService from '../service/ProcessoService';
import SessaoService from '../service/SessaoService';
import SustentacoesService from '../service/SustentacoesService';
import VersaoOrigemService from '../service/VersaoOrigemService';
import Configuracao from '../util/Configuracao';
dayjs.extend(customParseFormat);

class ReactComponent extends React.Component {
    // Atributos reutilizados
    timeoutPesquisar;
    disposers = [];
    processoPesquisa = { numero: '', digito: '', ano: '', orgao: '', regional: '', vara: '' };
    observableProps;

    // Stores
    get appStore() {
        return this.observableProps.stores.appStore;
    }
    get errorStore() {
        return this.observableProps.stores.errorStore;
    }
    get logStore() {
        return this.observableProps.stores.logStore;
    }
    get parametroStore() {
        return this.observableProps.stores.parametroStore;
    }
    get dominioStore() {
        return this.observableProps.stores.dominioStore;
    }
    get mensagemStore() {
        return this.observableProps.stores.mensagemStore;
    }
    get routerStore() {
        return this.observableProps.stores.routerStore;
    }
    get usuarioStore() {
        return this.observableProps.stores.usuarioStore;
    }
    get fotoMagistradoStore() {
        return this.observableProps.stores.fotoMagistradoStore;
    }
    get sessaoStore() {
        return this.observableProps.stores.sessaoStore;
    }
    get salaSessaoStore() {
        return this.observableProps.stores.salaSessaoStore;
    }
    get pautaJulgamentoStore() {
        return this.observableProps.stores.pautaJulgamentoStore;
    }
    get preSessaoStore() {
        return this.observableProps.stores.preSessaoStore;
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            processoPesquisa: observable,
            observableProps: observable,
            disposeReactions: action,
            filtrandoNumeroProcesso: computed,
            complementoMensagemFiltrando: computed,
            callbackNumeroProcesso: action,
            alertasProcessos: computed,
            adicionarObservable: action,
            isPreSessao: computed,
            isSalaSessao: computed,
            isPautaJulgamento: computed
        });

        runInAction(() => {
            this.observableProps = props;
        });
    }

    componentDidUpdate(prevProps) {
        runInAction(() => {
            if (prevProps !== this.props) {
                this.observableProps = this.props;
            }
        });
    }

    get nomeStore() {
        return this.routerStore.storeRotaAtual;
    }

    get store() {
        return this.observableProps.stores[this.nomeStore];
    }

    // Services
    _sessaoService;
    get sessaoService() {
        this._sessaoService = this._sessaoService ? this._sessaoService : new SessaoService(); // Inicialização tardia
        return this._sessaoService;
    }

    _pautaService;
    get pautaService() {
        this._pautaService = this._pautaService ? this._pautaService : new PautaService(); // Inicialização tardia
        return this._pautaService;
    }

    _certidaoService;
    get certidaoService() {
        this._certidaoService = this._certidaoService ? this._certidaoService : new CertidaoService();
        return this._certidaoService;
    }

    _acordaoService;
    get acordaoService() {
        this._acordaoService = this._acordaoService ? this._acordaoService : new AcordaoService();
        return this._acordaoService;
    }

    _processoService;
    get processoService() {
        this._processoService = this._processoService ? this._processoService : new ProcessoService();
        return this._processoService;
    }

    _assinaturaService;
    get assinaturaService() {
        this._assinaturaService = this._assinaturaService ? this._assinaturaService : new AssinaturaService();
        return this._assinaturaService;
    }

    _movimentoCNJService;
    get movimentoCNJService() {
        this._movimentoCNJService = this._movimentoCNJService ? this._movimentoCNJService : new MovimentoCNJService();
        return this._movimentoCNJService;
    }

    _healthCheckService;
    get healthCheckService() {
        this._healthCheckService = this._healthCheckService ? this._healthCheckService : new HealthCheckService();
        return this._healthCheckService;
    }

    _versaoOrigemService;
    get versaoOrigemService() {
        this._versaoOrigemService = this._versaoOrigemService ? this._versaoOrigemService : new VersaoOrigemService();
        return this._versaoOrigemService;
    }

    _advogadoSustentacaoOralService;
    get advogadoSustentacaoOralService() {
        this._advogadoSustentacaoOralService = this._advogadoSustentacaoOralService
            ? this._advogadoSustentacaoOralService
            : new AdvogadoSustentacaoOralService();
        return this._advogadoSustentacaoOralService;
    }

    _sustentacoesService;
    get sustentacoesService() {
        this._sustentacoesService = this._sustentacoesService ? this._sustentacoesService : new SustentacoesService();
        return this._sustentacoesService;
    }
    _validacaoPreSessaoService;
    get validacaoPreSessaoService() {
        this._validacaoPreSessaoService = this._validacaoPreSessaoService
            ? this._validacaoPreSessaoService
            : new ValidacaoPreSessaoService();
        return this._validacaoPreSessaoService;
    }
    // Outros métodos
    setTimeout(funcao, milliseconds) {
        return setTimeout(runInAction(funcao), milliseconds || 10);
    }

    isComponenteHabilitado(nomeComponente) {
        return this.parametroStore.isComponenteHabilitado(nomeComponente);
    }

    get nextKey() {
        return this.appStore.uniqueKey++;
    }

    createReaction(disposer) {
        if (process.env.REACT_APP_ENV === 'development') {
            this.disposers.push(() => disposer);
        } else {
            this.disposers.push(disposer);
        }
        return disposer;
    }

    createWhenReaction(predicate) {
        return this.createReaction(when(predicate, { timeout: Configuracao.DEFAULT_MOBX_TIMEOUT }));
    }

    componentWillUnmount() {
        this.disposeReactions();
    }

    disposeReactions() {
        this.disposers.forEach((disposer) => {
            if (typeof disposer === 'function') {
                disposer();
            }
        });
        this.disposers = [];
    }

    normalizarString(string) {
        return string
            ? (string + '')
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .toLowerCase()
            : '';
    }

    get isSalaSessao() {
        return this.nomeStore === 'salaSessaoStore';
    }

    get isPautaJulgamento() {
        return this.nomeStore === 'pautaJulgamentoStore';
    }

    get isPreSessao() {
        return this.nomeStore === 'preSessaoStore';
    }

    /**
     * @param {number} tamanhoEmBytes
     * @returns {string}
     */
    formatarTamanhoArquivo(tamanhoEmBytes) {
        const MENSAGEM_ARQUIVO_SEM_TAMANHO = 'Não foi possível verificar o tamanho do arquivo.';

        if (typeof tamanhoEmBytes !== 'number') {
            console.error(
                `Parâmetro inválido para \`formatarTamanhoArquivo\`: ${typeof tamanhoEmBytes}, esperado \`number\`.`
            );
            return MENSAGEM_ARQUIVO_SEM_TAMANHO;
        }

        if (tamanhoEmBytes < 0) {
            console.error(
                `Parâmetro inválido para \`formatarTamanhoArquivo\`: ${tamanhoEmBytes}, esperado um número maior ou igual a zero.`
            );
            return MENSAGEM_ARQUIVO_SEM_TAMANHO;
        }

        const ONE_KBYTE = 1024;
        const ONE_MEGABYTE = 1048576;
        const ONE_GIGABYTE = 1073741824;

        let tamanhoComUnidadeDeMedida = '';

        /**
         * @param {number} tamanho
         * @param {number} tamanhoUnidade
         * @returns {string}
         */
        function adicionarSinalAprox(tamanho, tamanhoUnidade) {
            return tamanho % tamanhoUnidade !== 0 ? '≈ ' : '';
        }

        if (tamanhoEmBytes < ONE_KBYTE) {
            tamanhoComUnidadeDeMedida += `${tamanhoEmBytes} Bytes`;
        } else if (tamanhoEmBytes < ONE_MEGABYTE) {
            tamanhoComUnidadeDeMedida += adicionarSinalAprox(tamanhoEmBytes, ONE_KBYTE);
            tamanhoComUnidadeDeMedida += `${Math.round(tamanhoEmBytes / ONE_KBYTE)} KB`;
        } else if (tamanhoEmBytes < ONE_GIGABYTE) {
            tamanhoComUnidadeDeMedida += adicionarSinalAprox(tamanhoEmBytes, ONE_MEGABYTE);
            tamanhoComUnidadeDeMedida += `${Math.round(tamanhoEmBytes / ONE_MEGABYTE)} MB`;
        } else {
            tamanhoComUnidadeDeMedida += adicionarSinalAprox(tamanhoEmBytes, ONE_GIGABYTE);
            tamanhoComUnidadeDeMedida += `${Math.round(tamanhoEmBytes / ONE_GIGABYTE)} GB`;
        }

        return tamanhoComUnidadeDeMedida;
    }

    descricaoTamanhoPeca(documento) {
        return documento?.tamanhoArquivo ? `[${this.formatarTamanhoArquivo(documento.tamanhoArquivo)}]` : '';
    }

    descricaoDataHoraPeca(documento) {
        const formatoDataHora = 'DD/MM/YYYY HH:mm:ss';
        return documento?.data
            ? dayjs(documento.data, Configuracao.FORMATO_DATAHORA_SERVICOS_PADRAO).format(formatoDataHora)
            : 'data/hora desconhecida';
    }

    descricaoPeca(documento) {
        return `${documento.tipoDocumento} - ${this.descricaoDataHoraPeca(documento)} ${this.descricaoTamanhoPeca(documento)}`;
    }

    // Devido à falta de padronização nos nomes dos complementos, é necessário subsituir os underlines por espaços
    corrigirString(string) {
        return string ? string.replace(/_/g, ' ').trim() : '';
    }

    get filtrandoNumeroProcesso() {
        return this.processoPesquisa && this.isProcessoPreenchido(this.processoPesquisa);
    }

    isProcessoPreenchido(processo) {
        return (
            processo &&
            (processo.numero !== '' ||
                processo.digito !== '' ||
                processo.ano !== '' ||
                processo.orgao !== '' ||
                processo.regional !== '' ||
                processo.vara !== '')
        );
    }

    get complementoMensagemFiltrando() {
        return this.store.existeFiltroAtivo || this.filtrandoNumeroProcesso
            ? ' que correspondem aos filtros selecionados'
            : '';
    }

    filtrarProcessoPeloNumero(registro) {
        return (
            registro.objetoNumeroProcesso &&
            this.compararNumeroProcesso(registro) &&
            this.compararDigitoProcesso(registro) &&
            this.compararAnoProcesso(registro) &&
            this.compararOrgaoProcesso(registro) &&
            this.compararRegionalProcesso(registro) &&
            this.compararVaraProcesso(registro)
        );
    }

    compararVaraProcesso(registro) {
        return (
            this.processoPesquisa.vara === '' ||
            registro.objetoNumeroProcesso.vara.indexOf(this.processoPesquisa.vara) > -1
        );
    }

    compararRegionalProcesso(registro) {
        return (
            this.processoPesquisa.regional === '' ||
            registro.objetoNumeroProcesso.regional.indexOf(this.processoPesquisa.regional) > -1
        );
    }

    compararOrgaoProcesso(registro) {
        return (
            this.processoPesquisa.orgao === '' ||
            registro.objetoNumeroProcesso.orgao.indexOf(this.processoPesquisa.orgao) > -1
        );
    }

    compararAnoProcesso(registro) {
        return (
            this.processoPesquisa.ano === '' ||
            registro.objetoNumeroProcesso.ano.indexOf(this.processoPesquisa.ano) > -1
        );
    }

    compararDigitoProcesso(registro) {
        return (
            this.processoPesquisa.digito === '' ||
            registro.objetoNumeroProcesso.digito.indexOf(this.processoPesquisa.digito) > -1
        );
    }

    compararNumeroProcesso(registro) {
        return (
            this.processoPesquisa.numero === '' ||
            registro.objetoNumeroProcesso.numero.indexOf(this.processoPesquisa.numero) > -1
        );
    }

    callbackNumeroProcesso = (numeroProcesso) => {
        if (this.isProcessoPreenchido(numeroProcesso)) {
            if (this.timeoutPesquisar) {
                clearTimeout(this.timeoutPesquisar);
            }
            this.timeoutPesquisar = setTimeout(() => runInAction(() => (this.processoPesquisa = numeroProcesso)), 100);
        } else if (this.filtrandoNumeroProcesso) {
            this.limparProcessoPesquisa();
        }
    };

    getDescricaoOpcaoSessao(sessao) {
        const chavesDescricaoPorSessao = Object.keys(sessao.descricaoPorSessao);
        let descricaoSessao;

        if (chavesDescricaoPorSessao.length === 1 || this.isTodasSessoesMesmoHorario(sessao)) {
            descricaoSessao = this.getHoraSessao(sessao, chavesDescricaoPorSessao[0]) + ': ' + sessao.descricao;
        } else {
            descricaoSessao = this.getDescricaoSessaoCompostaHorariosDivergentes(sessao);
        }

        return (
            <Typography
                display={'inline'}
                style={{ fontWeight: this.getDestaqueSessao(sessao) }}
            >
                {sessao.tipoJulgamento === MEIO_JULGAMENTO_SESSAO.VIRTUAL.codigo &&
                sessao.prazos.dataInicioVotacaoVirtual ? (
                    sessao.tipo +
                    ' - ' +
                    moment(sessao.prazos.dataInicioVotacaoVirtual, 'DD-MM-YYYY-HH-mm-ss').format('DD/MM/YYYY') +
                    ' a ' +
                    moment(sessao.prazos.dataFimVotacaoVirtualExibicao, 'DD-MM-YYYY-HH-mm-ss').format('DD/MM/YYYY') +
                    ': ' +
                    sessao.descricao
                ) : (
                    <span style={{ display: 'inline', fontWeight: this.getDestaqueSessao(sessao) }}>
                        {sessao.tipo +
                            ' - ' +
                            moment(sessao.prazos.dataInicioSessaoPresencial, 'DD-MM-YYYY-HH-mm-ss').format(
                                'DD/MM/YYYY'
                            ) +
                            ' '}{' '}
                        {descricaoSessao}
                    </span>
                )}
                {this.getDescricaoTipoJulgamento(sessao) + ' (' + sessao.quantidadeTotalProcessos + ')'}
                {this.getSinalizadoresSessaoEmAndamento(sessao)}
            </Typography>
        );
    }

    getDescricaoSessaoCompostaHorariosDivergentes(sessao) {
        let horasDescricoes = Object.keys(sessao.descricaoPorSessao).reduce((acc, sessaoId) => {
            const horaSessao = this.getHoraSessao(sessao, sessaoId);
            let horaSessoes = acc.find((horaDesc) => horaDesc.horaSessao === horaSessao);
            if (!horaSessoes) {
                horaSessoes = { horaSessao: horaSessao, sessoesPJe: [], sessoesSIJ: [] };
                acc.push(horaSessoes);
            }
            if (sessaoId.indexOf(Configuracao.ORIGEM_PJE) > -1) {
                horaSessoes.sessoesPJe.push(sessao.descricaoPorSessao[sessaoId].split(' ')[1]);
            } else {
                horaSessoes.sessoesSIJ.push(sessao.descricaoPorSessao[sessaoId].split(' ')[1]);
            }
            return acc;
        }, []);
        horasDescricoes.sort((a, b) => a.horaSessao.localeCompare(b.horaSessao));
        horasDescricoes.forEach((horaDescricao) => {
            horaDescricao.sessoesSIJ = horaDescricao.sessoesSIJ.sort((a, b) => a.localeCompare(b));
            horaDescricao.sessoesPJe = horaDescricao.sessoesPJe.sort((a, b) => a.localeCompare(b));
        });
        return horasDescricoes.map((horaDescricao, index) => {
            return (
                <span key={this.nextKey}>
                    <b>{horaDescricao.horaSessao + ': '}</b>
                    {horaDescricao.sessoesSIJ.length > 0 &&
                        Configuracao.ORIGEM_SIJ + ' ' + horaDescricao.sessoesSIJ.join(', ')}
                    {horaDescricao.sessoesSIJ.length > 0 && horaDescricao.sessoesPJe.length > 0 && '; '}
                    {horaDescricao.sessoesPJe.length > 0 &&
                        Configuracao.ORIGEM_PJE + ' ' + horaDescricao.sessoesPJe.join(', ')}
                    {index < horasDescricoes.length - 1 && '; '}
                </span>
            );
        });
    }

    isTodasSessoesMesmoHorario(sessao) {
        let horasSessoes = Object.keys(sessao.prazosPorSessao).map((key) =>
            this.getHora(sessao.prazosPorSessao[key].dataInicioSessaoPresencial)
        );
        return horasSessoes.every((horaSessao) => horaSessao === horasSessoes[0]);
    }

    getHoraSessao(sessao, sessaoId) {
        return this.getHora(sessao.prazosPorSessao[sessaoId].dataInicioSessaoPresencial);
    }

    getHora(data) {
        return moment(data, 'DD-MM-YYYY-HH-mm-ss').format('HH:mm');
    }

    getDescricaoTipoJulgamento(sessao) {
        switch (sessao.tipoJulgamento) {
            case 'TELEPRESENCIAL':
                return ' - Telepresencial';
            case 'HIBRIDA':
                return ' - Híbrida';
            default:
                return '';
        }
    }

    getTipoJulgamentoCapitalizado(sessao) {
        return sessao.tipoJulgamento.charAt(0).toUpperCase() + sessao.tipoJulgamento.slice(1).toLowerCase();
    }

    getSinalizadorProximaSessao(sessao) {
        return (sessao.proxima ? ' (Próxima)' : '') + (sessao.hoje ? ' (Hoje)' : '');
    }

    getSinalizadoresSessaoEmAndamento(sessao) {
        return sessao.tipoJulgamento === MEIO_JULGAMENTO_SESSAO.VIRTUAL.codigo
            ? this.getSinalizadoresSessaoVirtual(sessao)
            : this.getSinalizadorProximaSessao(sessao);
    }

    getSinalizadoresSessaoVirtual(sessao) {
        if (
            moment().isBetween(
                moment(sessao.prazos.dataInicioVotacaoVirtual, 'DD-MM-YYYY-HH-mm-ss'),
                moment(sessao.prazos.dataFimVotacaoVirtual, 'DD-MM-YYYY-HH-mm-ss')
            )
        ) {
            return sessao.hoje ? ' (Hoje)' : ' (Em andamento)';
        }
    }

    getDestaqueSessao(sessao) {
        if (moment().isAfter(moment(sessao.prazos.dataFimVotacaoVirtual, 'DD-MM-YYYY-HH-mm-ss'))) {
            return '';
        } else if (
            (sessao.tipoJulgamento === MEIO_JULGAMENTO_SESSAO.VIRTUAL.codigo &&
                moment().isBetween(
                    moment(sessao.prazos.dataInicioVotacaoVirtual, 'DD-MM-YYYY-HH-mm-ss'),
                    moment(sessao.prazos.dataFimVotacaoVirtual, 'DD-MM-YYYY-HH-mm-ss')
                )) ||
            sessao.hoje ||
            sessao.proxima
        ) {
            return 'bold';
        }
    }

    get alertasProcessos() {
        let retorno = [];
        let alertas;
        this.processos.forEach((registro) => {
            alertas = this.getAlertasProcesso(registro);
            if (alertas && alertas.length > 0) {
                retorno.push({ numeroProcesso: registro.processo.numeroCompleto, alertas: alertas });
            }
        });
        return retorno;
    }

    cancelarRequisicoesPendentes() {
        Ambiente.cancelarRequisicoes();
        this.appStore.zerarRequisicoes();
    }

    adicionarObservable(objeto, propriedade, valor) {
        if (!Object.prototype.hasOwnProperty.call(objeto, propriedade)) {
            extendObservable(objeto, {
                [propriedade]: valor
            });
        }
    }

    redirecionar = (rota) => {
        this.baseUrl =
            Ambiente.baseUrl.contexto !== undefined && Ambiente.baseUrl.contexto !== ''
                ? '/' + Ambiente.baseUrl.contexto
                : process.env.PUBLIC_URL
                  ? process.env.PUBLIC_URL
                  : '';
        this.setTimeout(() => {
            this.errorStore.reset();
            this.routerStore.push(this.baseUrl + rota);
        });
    };
}

ReactComponent.propTypes = {
    stores: PropTypes.object.isRequired
};

export default ReactComponent;
